import { Star, StarOutline } from '@mui/icons-material'
import { Box } from '@mui/material'

export interface StarsProps {
  count: number
  max: number
  widget?: boolean
}

/**
 * Convert currency to Starsbol.
 */
export const Stars = (props: StarsProps): JSX.Element => {
  const { count, max, widget } = props
  const stars: JSX.Element[] = []
  for (let i = 0; i < max; i++) {
    if (i < count) {
      stars.push(<Star sx={{ color: widget ? 'black' : 'primary.main' }} key={i}/>)
    } else {
      stars.push(<StarOutline key={i}/>)
    }
  }
  return <Box component="span" sx={{ display: 'inline-block', transform: 'translateY(5px)' }}>
    {stars}
  </Box>
}
